import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const dashboard = createQueryKeys('dashboard', {
  referrals: null,
  deals: null,
})

export type QueryKeys = inferQueryKeys<typeof dashboard>
